var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsightsExplainHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 373,
    fill: "none",
    viewBox: "0 0 375 373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h375v373H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h375v373H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 185,
    x: 120,
    y: -70,
    fill: "#fff",
    rx: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 118,
    x: 120,
    y: 127,
    fill: "#0058A3",
    rx: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 270,
    x: 10,
    y: -25,
    fill: "#fff",
    rx: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 238,
    x: -42,
    y: 255,
    fill: "#fff",
    rx: 31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 186,
    r: 31,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M134 13v32H87V13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD3F",
    fillRule: "evenodd",
    d: "M185.5 196v-7H184v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H182v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD3F",
    d: "m188.5 183.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M293.5 172v-7H292v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H290v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m296.5 159.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "evenodd",
    d: "M330.5 55v-7H329v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H327v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "m333.5 42.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "evenodd",
    d: "M168.5 88v-7H167v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H165v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "m171.5 75.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "evenodd",
    d: "M56.5 57v-7H55v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H53v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "m59.5 44.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "evenodd",
    d: "M56.5 186v-7H55v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H53v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "m59.5 173.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "evenodd",
    d: "M44.5 309v-7H43v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H41v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "m47.5 296.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "evenodd",
    d: "M310.5 353v-7H309v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H307v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "m313.5 340.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M332.5 214v-7H331v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H329v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m335.5 201.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M253.5 214v-7H252v2h-3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h3v2h1.5v-7h2v20h-2Zm0-11v2H250v2h-1a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h1v2h3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m256.5 201.2 1 6 2-.4-1-6-2 .4Zm3.6 0 1 6 2-.4-1-6-2 .4Zm4.3 5-.6-4 2-.4.6 4-2 .4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h375v373H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsExplainHome);
export default __webpack_public_path__ + "static/media/insights-explain-home.03027ae99dc9036cd431e8adcf2c12df.svg";
export { ForwardRef as ReactComponent };